The capabilities of the requesting partner to act on behalf of the hiring organization.
